export class ServiceBody {
    myNumber: string;
    mySignupPassword: string;
    otpId: string;
    name: string;
    address: string;
    userId: string; 
}